import { Form, Input, Button, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ChangePasswordService from '../../services/ChangePasswordService';
import { useAuth } from '../../hooks/useAuth';

const ChangePassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { showNotification } = useAuth();

  // API call
  const onFinish = async formValues => {
    const payload = {
      oldPasscode: formValues.currentPassword,
      newPasscode: formValues.newPassword,
      confirmPasscode: formValues.confirmPassword,
    };

    console.log(payload);

    const result = await ChangePasswordService.performChangePassword(payload);

    console.log(result);

    if (result.success) {
      showNotification('success', 'Password Changed Successfully');
      navigate(-1);
    } else {
      showNotification('error', result.message);
    }
  };

  return (
    <>
      <Typography.Title level={4}>Change Password</Typography.Title>
      <Form
        style={{ maxWidth: '600px', margin: '0 auto', padding: '2rem 0' }}
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 8,
        }}
      >
        <Form.Item
          label={'Current Password'}
          name={'currentPassword'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label={'New Password'}
          name={'newPassword'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label={'Confirm Password'}
          name={'confirmPassword'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
      <Button type="default" size={'large'} onClick={() => navigate(-1)}>
        <ArrowLeftOutlined /> Back
      </Button>
    </>
  );
};

export default ChangePassword;
